import React, {useMemo} from 'react'
import ReactApexChart from 'react-apexcharts'
import {Spinner} from 'react-bootstrap'
import {buildChartClickEvents} from './chartPointClick'
import {ChartActiveFilterHeader} from './ChartActiveFilterHeader'

export type FilterOption = {
  value: string
  label: string
}

type Props = {
  className: string
  loading: boolean
  series: {name: string; data: any[]}[]
  options: {
    chart: {height: number; type: 'area'}
    dataLabels: {enabled: boolean}
    stroke: {curve: 'smooth'}
    xaxis: {categories: any[]}
    tooltip: any
  }
  totalPengguna: number
  kota: string
  jenjang: string
  mitra: string
  bulanAwal: string
  bulanAkhir: string
  tahunAwal: string
  tahunAkhir: string
  onPointClick?: (label: string, value: number, index: number) => void
}

const ChartPengguna: React.FC<Props> = ({
  className,
  loading,
  series,
  options,
  totalPengguna,
  kota,
  jenjang,
  mitra,
  bulanAwal,
  bulanAkhir,
  tahunAwal,
  tahunAkhir,
  onPointClick,
}) => {
  const chartData = series[0]?.data || []
  const hasData = Array.isArray(chartData) && chartData.length > 0

  const chartOptions = useMemo(
    () => ({
      ...options,
      markers: {
        size: 5,
        hover: {
          size: 7,
        },
      },
      tooltip: {
        ...options.tooltip,
        intersect: true,
        shared: false,
      },
      chart: {
        ...options.chart,
        events: buildChartClickEvents(
          options.xaxis.categories,
          series[0]?.data,
          onPointClick
        ),
      },
    }),
    [options, series, onPointClick]
  )

  return (
    <div className={`card ${className} container`}>
      <div className='card-body d-flex flex-column p-0'>
        <div className='flex-grow-1 card-p pb-0'>
          <div className='d-flex flex-stack flex-wrap mb-5'>
            <div className='me-2'>
              <div className='text-dark text-hover-primary fw-bold fs-3'>Statistik Pengguna</div>
            </div>
            {loading ? (
              <Spinner animation='border' size='sm' />
            ) : (
              <div className='fw-bold fs-3'>Total: {totalPengguna} Pengguna</div>
            )}
          </div>

          <ChartActiveFilterHeader
            kota={kota}
            jenjang={jenjang}
            mitra={mitra}
            bulanAwal={bulanAwal}
            bulanAkhir={bulanAkhir}
            tahunAwal={tahunAwal}
            tahunAkhir={tahunAkhir}
          />

          <div className='mixed-widget-7-chart card-rounded-bottom'>
            {loading ? (
              <div className='d-flex align-items-center justify-content-center py-10'>
                <Spinner animation='border' role='status' />
              </div>
            ) : hasData ? (
              <ReactApexChart options={chartOptions} series={series} type='area' height={350} />
            ) : (
              <div className='alert alert-danger text-center'>Tidak ada data</div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export {ChartPengguna}
